import AxiosService from '../AxiosService';

const CLiENT_ENDPOINT = "/api/v1/admin/clients"

export default class ClientService {
  constructor() {
    this.service = new AxiosService();
  }

  save(clientName) {
    let payload = {
      'name': clientName
    }
    return this.service.post(CLiENT_ENDPOINT, payload, null);
  }

  change(id, payload) {
    return this.service.post(CLiENT_ENDPOINT + `/${id}`, payload, null);
  }

  delete(id) {
    return this.service.delete(CLiENT_ENDPOINT + `/${id}`);
  }
}
